"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _material = require("@mui/material");
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _wouter = require("wouter");
var _Style = require("../../style/Style");
var _form = require("../../components/form");
var _common = require("../../store/common");
var _company = require("../../store/company");
var _user = require("../../store/user");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const App = props => {
  const [, setLocation] = (0, _wouter.useLocation)();
  const {
    setToastOpen,
    setToastText,
    setIsLoading,
    setLoadingMessage
  } = (0, _common.useCommonStore)();
  const {
    checkNewEmail,
    setNewEmail,
    setNewEmailConfirm,
    setCurrentEmail,
    newEmail,
    newEmailConfirm,
    updateEmail
  } = (0, _user.useUserStore)();
  const {
    setCurrentCompanyById,
    initCurrentCompany,
    currentCompany,
    errors,
    submitting
  } = (0, _company.useCompanyStore)();
  const emailRef = (0, _react.useRef)(null);
  const emailConfirmRef = (0, _react.useRef)(null);
  const submitButtonRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    (async () => {
      if (!props.id) {
        initCurrentCompany();
        return;
      }
      setIsLoading(true);
      const company = await setCurrentCompanyById(props.id);
      console.log(company);
      setCurrentEmail(company.adminEmail);
      setIsLoading(false);
    })();
  }, []);
  const onLoadingTextChanged = text => {
    setLoadingMessage(text);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Grid2, {
    container: true,
    ...stylex.props(_Style.wrapper.main),
    spacing: 4,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Grid2, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        ...stylex.props(_Style.buttonStyle.secondary),
        onClick: () => {
          setLocation('/companies');
        },
        children: "\uFF1C\u623B\u308B"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Grid2, {
      container: true,
      ...stylex.props(_Style.wrapper.mainTitle),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        ...stylex.props(_Style.textStyle.h1),
        children: "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u5909\u66F4"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Grid2, {
      container: true,
      spacing: 2,
      direction: 'column',
      ...stylex.props(_Style.wrapper.stretchW),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
        children: ["\u73FE\u5728\u306E\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9: ", currentCompany.adminEmail]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_form.FormFieldInput, {
        label: "\u65B0\u3057\u3044\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9",
        ref: emailRef,
        type: "text",
        value: newEmail,
        errorText: errors.newEmail,
        placeholder: '新しいメールアドレスを入力してください)',
        onChange: event => {
          setNewEmail(event.target.value);
        },
        onEnterKey: () => {
          var _emailConfirmRef$curr;
          (_emailConfirmRef$curr = emailConfirmRef.current) === null || _emailConfirmRef$curr === void 0 ? void 0 : _emailConfirmRef$curr.focus();
        }
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_form.FormFieldInput, {
        label: "\u65B0\u3057\u3044\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9(\u78BA\u8A8D\u7528)",
        ref: emailConfirmRef,
        type: "text",
        value: newEmailConfirm,
        errorText: errors.newEmailConfirm,
        placeholder: '新しいメールアドレス(確認用)を入力してください)',
        onChange: event => {
          setNewEmailConfirm(event.target.value);
        },
        onEnterKey: () => {
          var _submitButtonRef$curr;
          (_submitButtonRef$curr = submitButtonRef.current) === null || _submitButtonRef$curr === void 0 ? void 0 : _submitButtonRef$curr.focus();
        }
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        ...stylex.props(_Style.buttonStyle.primary),
        disabled: submitting,
        ref: submitButtonRef,
        onClick: async () => {
          setIsLoading(true);
          if (!(await checkNewEmail())) {
            setIsLoading(false);
            return;
          }
          setIsLoading(false);
          if (!window.confirm('メールアドレスを変更しますか？')) {
            return;
          }
          setIsLoading(true);
          const result = await updateEmail(onLoadingTextChanged, currentCompany.adminUserId, currentCompany.name + ' 管理者', currentCompany.adminEmail);
          if (!result) {
            setIsLoading(false);
            return false;
          }
          setToastOpen(true);
          setToastText('メールアドレス確認メールを送信しました');
          setLocation('/companies');
          setIsLoading(false);
          return;
        },
        children: submitting ? 'メールアドレス変更中...' : 'メールアドレスを変更する'
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Grid2, {
        minHeight: 48,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          ...stylex.props(_Style.textStyle.error),
          children: errors.submit
        })
      })]
    })]
  });
};
var _default = exports.default = App;